<template>
  <div class="row">
    <div class="col-md-6 offset-md-3 col-sm-12 offset-sm-1">
      <form id="login-form" role="form" style="display: block;">
        <h3 class="text-center">Ingresar</h3>
        <div class="form-group">
          <input
            type="email"
            name="email"
            id="email"
            class="form-control"
            :class="{'is-invalid': !validEmail.result}"
            placeholder="Correo*"
            v-model="email"
          />
          <div class="invalid-feedback">{{ validEmail.message }}</div>
        </div>
        <div class="form-group">
          <input
            type="password"
            name="password"
            id="password"
            class="form-control"
            :class="{'is-invalid': !validPassword.result}"
            placeholder="Contraseña*"
            v-model="password"
          />
          <div class="invalid-feedback">{{ validPassword.message }}</div>
        </div>

        <div class="form-group">
          <button class="btn btn-success w-100" :disabled="disabled" @click.prevent="loginWithEmailLocal">Ingresar</button>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-lg-12">
              <div class="text-center">
                <router-link to="/register">
                  <a>Registrarse</a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { isValidField } from "@/utils/formValidation";
export default {
  data() {
    return {
      email: "",
      password: ""
    };
  },
  computed: {
    disabled() {
      return !(this.validEmail.result && this.validPassword.result)
    },
    validEmail() {
      return isValidField(this.email, ['required', 'email'])
    },
    validPassword() {
      return isValidField(this.password, ['required'])
    }
  },
  methods: {
    ...mapActions(["addMessage", "clearMessage", "loginWithEmail"]),
    loginWithEmailLocal() {
      let data = {
        email: this.email,
        password: this.password
      };
      this.loginWithEmail(data);
    }
  }
};
</script>
